import LicensePanel from './LicensePanelConnector';

export default LicensePanel;
